import { render, staticRenderFns } from "./ppt.vue?vue&type=template&id=1f791c6b&scoped=true"
import script from "./ppt.vue?vue&type=script&lang=js"
export * from "./ppt.vue?vue&type=script&lang=js"
import style0 from "./ppt.vue?vue&type=style&index=0&id=1f791c6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f791c6b",
  null
  
)

export default component.exports